// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/fixture.css
// module id = 814
// module chunks = 1